import { useMemo } from 'react';
import { getDistributionConfig } from 'distribution';

/**
 * @deprecated Use getDistributionConfig directly
 */
export default function useDistribution(index = []) {
  return useMemo(() => getDistributionConfig(index), [index]);
}
